export const astroStarModalPath = 'astro-star-modal'
export const astroStarModalFormPath = 'astro-form'
export const astroStarModalCouplePath = 'astro-couple'
export const astroStarModalAgreementPath = 'astro-agreement'
